var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import styled from 'styled-components';
import { useNotificationState, useClear } from '../hooks/notificationHook';
var StyledAlert = styled(MuiAlert)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: white;\n"], ["\n  color: white;\n"])));
function Alert(props) {
    return React.createElement(StyledAlert, __assign({ elevation: 6, variant: "filled" }, props));
}
var List = styled.ul(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  min-width: 200px;\n"], ["\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  min-width: 200px;\n"])));
var ListItem = styled.li(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin: 0;\n"], ["\n  margin: 0;\n"])));
var Notification = function () {
    var notification = useNotificationState();
    var clear = useClear();
    var open = notification.messages.length > 0;
    var handleClose = React.useCallback(function () { return clear(); }, [clear]);
    var handleSnackbarClose = React.useCallback(function (_, reason) {
        if (reason !== 'clickaway') {
            clear();
        }
    }, [clear]);
    return (React.createElement(Snackbar, { open: open, anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'left',
        }, autoHideDuration: 10000, onClose: handleSnackbarClose },
        React.createElement("div", null,
            React.createElement(Alert, { onClose: handleClose, severity: notification.type },
                React.createElement(List, null, notification.messages.map(function (m) { return (React.createElement(ListItem, { key: m }, m)); }))))));
};
export default Notification;
var templateObject_1, templateObject_2, templateObject_3;
